"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _getLanguageFromUrl = _interopRequireDefault(require("../getLanguageFromUrl"));
var addLanguagePrefixToUrl = function addLanguagePrefixToUrl(prefix) {
  return function (url) {
    var subpath = (0, _getLanguageFromUrl["default"])(url, prefix.replace("/", ""));
    return subpath ? url : prefix + url;
  };
};
var _default = addLanguagePrefixToUrl;
exports["default"] = _default;